<template>
    <div :class="['multi-select', modify, {'is-open': isOpen}]" ref="select">
        <div class="multi-select__toggle" @click="toggleOpen">
            <span class="multi-select__caption">{{ placeholder }}</span>
            <span class="multi-select__fake-arrow">
                <svg width="10" height="6">
                    <use xlink:href="/webicons/sprite.svg#i-arr-down"></use>
                </svg>
            </span>
        </div>

        <transition name="fade-filter" mode="out-in">
            <div v-show="isMobile && isOpen" class="multi-select__fix" ref="fixedList">
                <div class="multi-select__fix-overlay" @click="closeFixedList"></div>
                <div class="grid__container">
                    <div class="multi-select__fix-content">
                        <CheckboxList v-if="type === 'checkbox'" :select="select" view="mobile" @changeFilter="change"/>
                        <RadioList v-if="type === 'radio'" :select="select" view="mobile" @changeFilter="change"/>
                        <div class="multi-select__fix-submit" @click="closeFixedList">Применить</div>
                    </div>
                </div>
            </div>
        </transition>

        <div v-if="!isMobile" :class="['multi-select__list-wrap', {'is-top': isTop}]"
             :style="{height: heightList}" ref="list">
            <CheckboxList v-if="type === 'checkbox'" :select="select" view="desktop" @changeFilter="change"/>
            <RadioList v-if="type === 'radio'" :select="select" view="desktop" @changeFilter="change"/>
        </div>
    </div>
</template>

<script>
import CheckboxList from './components/CheckboxList.vue';
import RadioList from './components/RadioList.vue';
import {Utils} from 'common/scripts/utils';

export default {
    props: ['modify', 'type', 'select', 'windowWidth'],

    components: {
        CheckboxList,
        RadioList
    },

    data() {
        return {
            isOpen    : false,
            heightList: 0,
            isMobile  : this.windowWidth < 960,
            isTop     : false
        };
    },

    computed: {
        placeholder() {
            let selected = null;
            let separator = ', ';

            if (this.type === 'checkbox') {
                selected = this.select.options.filter((option) => {
                    return option.selected;
                });
            } else if (this.type === 'radio') {
                this.select.options.forEach((option) => {
                    if (option.options) {
                        selected = option.options.filter((suboption) => {
                            return suboption.selected;
                        });
                        separator = ' и ';
                    } else if (option.value === this.select.value) {
                        selected = [option];
                    }
                });
            }

            const text = selected.map((option) => {
                return option.text;
            });

            if (text.length) {
                return text.join(separator);
            }

            return this.select.placeholder;
        }
    },

    watch: {
        windowWidth(newValue) {
            this.isMobile = newValue < 960;
        }
    },

    methods: {
        change() {
            this.$nextTick(() => {
                this.$emit('change');
            });
        },

        toggleOpen() {
            if (this.windowWidth < 960) {
                this.isOpen = true;
                Utils.bodyFixed(this.$refs.fixedList);
            } else if (this.isOpen) {
                this.hideList();
            } else {
                this.showList();
            }
        },

        closeFixedList() {
            Utils.bodyStatic();
            this.isOpen = false;
        },

        hideList() {
            this.isOpen = false;
            this.heightList = '0px';
        },

        showList() {
            this.isOpen = true;
            this.heightList = `${this.getHeightList()}px`;
            this.setDirection();
        },

        getHeightList() {
            if (!this.$refs.list) {
                return 0;
            }

            return this.$refs.list.scrollHeight;
        },

        setDirection() {
            const select = this.$refs.select;

            const windowHeight = window.innerHeight || document.documentElement.clientHeight;
            const listPosition = select.getBoundingClientRect().top + select.getBoundingClientRect().height + 16;
            const listHeight = this.getHeightList();

            this.isTop = windowHeight < listPosition + listHeight;
        },

        setHeightOnResize() {
            if (this.isOpen) {
                this.heightList = `${this.getHeightList()}px`;
            }
        },

        clickOutside() {
            const target = event.target;
            const selectWrapper = this.$refs.select;

            if (!this.isDescendant(selectWrapper, target)) {
                this.hideList();
            }
        },

        isDescendant(parent, child) {
            let node = child.parentNode;

            while (node !== null) {
                if (node === parent) {
                    return true;
                }
                node = node.parentNode;
            }

            return false;
        }
    },

    mounted() {
        document.body.addEventListener('click', this.clickOutside, false);
    },

    destroyed() {
        document.body.removeEventListener('click', this.clickOutside, false);
    }
};
</script>
